// 流程
export const NODELIST = [
  {
    title: '自定义模板信息',
    isDone: false,
    key: 'templateInfo'
  },
  {
    title: '自定义模板表格',
    isDone: false,
    key: 'templateTable'
  },
  {
    title: '发货地站点信息',
    isDone: false,
    key: 'destinationInfo'
  },
  {
    title: '收货地站点信息',
    isDone: false,
    key: 'receivingInfo'
  },
  {
    title: '货品信息',
    isDone: false,
    key: 'goodsInfo'
  },
  {
    title: '其他信息',
    isDone: true,
    key: 'otherInfo'
  }
]
// 发货地字段列表
export const DESTINATIONFIELDLIST = {
  STATION_CODE:[{
      label: '要求取货时间',
      prop: 'startTime',
      default: 'defaultStartTime',
      type: 'time',
    },
    {
      label: '发货地站点编码',
      prop: 'stationCode',
      default: 'defaultStationCode',
    },
  ],
  STATION_ADDRESS: [
    {
      label: '要求取货时间',
      prop: 'startTime',
      default: 'defaultStartTime',
      type: 'time',
    },
    {
      label: '发货地详情地址',
      prop: 'address',
      default: 'defaultAddress',
    },
    {
      label: '发货地联系人姓名',
      prop: 'stationContacts',
      default: 'defaultStationContacts',
    },
    {
      label: '发货地联系人电话',
      prop: 'stationContactsPhone',
      default: 'defaultStationContactsPhone',
    },
    {
      label: '发货地站点名称',
      prop: 'stationName',
      default: 'defaultStationName',
    },
  ],
  FULL_ADDRESS: [
    {
      label: '要求取货时间',
      prop: 'startTime',
      default: 'defaultStartTime',
      type: 'time',
    },
    {
      label: '发货地省份',
      prop: 'province',
      default: 'defaultProvince',
    },
    {
      label: '发货地城市',
      prop: 'city',
      default: 'defaultCity',
    },
    {
      label: '发货地区县',
      prop: 'county',
      default: 'defaultCounty',
    },
    {
      label: '发货地详情地址',
      prop: 'address',
      default: 'defaultAddress',
    },
    {
      label: '发货地联系人姓名',
      prop: 'stationContacts',
      default: 'defaultStationContacts',
    },
    {
      label: '发货地联系人电话',
      prop: 'stationContactsPhone',
      default: 'defaultStationContactsPhone',
    },
    {
      label: '发货地站点名称',
      prop: 'stationName',
      default: 'defaultStationName',
    },
  ]
}

// 发货地导入方式
export const DESTINATIONTYPELIST = [
  {
    value: 'STATION_CODE',
    label: '站点编码导入'
  },
  {
    value: 'STATION_ADDRESS',
    label: '详细地址导入'
  },
  {
    value: 'FULL_ADDRESS',
    label: '省/市/区+详细地址导入'
  },
]

// 发货地字段校验规则
export const DESTINATIONRULES = {
  startTime: [
    { required: true, message: '请选择要求取货时间', trigger: 'change' },
  ],
  stationCode: [
    { required: true, message: '请选择发货地站点编码', trigger: 'change' },
  ],
  address: [
    { required: true, message: '请选择发货地详细地址', trigger: 'change' },
  ],
  stationContacts: [
    { required: true, message: '请选择发货地联系人姓名', trigger: 'change' },
  ],
  stationContactsPhone: [
    { required: true, message: '请选择发货地联系人电话', trigger: 'change' },
  ],
  province: [
    { required: true, message: '请选择发货地省份', trigger: 'change' },
  ],
  city: [
    { required: true, message: '请选择发货地城市', trigger: 'change' },
  ],
  county: [
    { required: true, message: '请选择发货地区县', trigger: 'change' },
  ],
  defaultStationContactsPhone: [
    { pattern: /^\d{1,12}$/, message: '请输入正确的手机号', trigger: 'blur' },
  ]
}

// 收货地字段列表
export const RECEIVINGFIELDLIST = {
  STATION_CODE:[
    {
      label: '期望送达时间',
      prop: 'endTime',
      default: 'defaultEndTime',
      type: 'time',
    },
    {
      label: '收货地站点编码',
      prop: 'stationCode',
      default: 'defaultStationCode',
    },
  ],
  STATION_ADDRESS: [
    {
      label: '期望送达时间',
      prop: 'endTime',
      default: 'defaultEndTime',
      type: 'time',
    },
    {
      label: '收货地详情地址',
      prop: 'address',
      default: 'defaultAddress',
    },
    {
      label: '收货地联系人姓名',
      prop: 'stationContacts',
      default: 'defaultStationContacts',
    },
    {
      label: '收货地联系人电话',
      prop: 'stationContactsPhone',
      default: 'defaultStationContactsPhone',

    },
    {
      label: '收货地站点名称',
      prop: 'stationName',
      default: 'defaultStationName',
    },
  ],
  FULL_ADDRESS: [
    {
      label: '期望送达时间',
      prop: 'endTime',
      default: 'defaultEndTime',
      type: 'time',
    },
    {
      label: '收货地省份',
      prop: 'province',
      default: 'defaultProvince',
    },
    {
      label: '收货地城市',
      prop: 'city',
      default: 'defaultCity',
    },
    {
      label: '收货地区县',
      prop: 'county',
      default: 'defaultCounty',
    },
    {
      label: '收货地详情地址',
      prop: 'address',
      default: 'defaultAddress',
    },
    {
      label: '收货地联系人姓名',
      prop: 'stationContacts',
      default: 'defaultStationContacts',
    },
    {
      label: '收货地联系人电话',
      prop: 'stationContactsPhone',
      default: 'defaultStationContactsPhone',
    },
    {
      label: '收货地站点名称',
      prop: 'stationName',
      default: 'defaultStationName',
    },
  ]
}

// 收货地导入类型
export const RECEIVINGTYPELIST = [
  {
    value: 'STATION_CODE',
    label: '站点编码导入'
  },
  {
    value: 'STATION_ADDRESS',
    label: '详细地址导入'
  },
  {
    value: 'FULL_ADDRESS',
    label: '省/市/区+详细地址导入'
  },
]

// 收货地字段校验规则
export const RECEIVINGRULES = {
  endTime: [
    { required: true, message: '请选择要求取货时间', trigger: 'change' },
  ],
  stationCode: [
    { required: true, message: '请选择收货地站点编码', trigger: 'change' },
  ],
  address: [
    { required: true, message: '请选择发货地详细地址', trigger: 'change' },
  ],
  stationContacts: [
    { required: true, message: '请选择收货地联系人姓名', trigger: 'change' },
  ],
  stationContactsPhone: [
    { required: true, message: '请选择收货地联系人电话', trigger: 'change' },
  ],
  province: [
    { required: true, message: '请选择收货地省份', trigger: 'change' },
  ],
  city: [
    { required: true, message: '请选择收货地城市', trigger: 'change' },
  ],
  county: [
    { required: true, message: '请选择收货地区县', trigger: 'change' },
  ],
  defaultStationContactsPhone: [
    { pattern: /^\d{1,12}$/, message: '请输入正确的手机号', trigger: 'blur' },
  ]
}

const TEMPERATURES = [
  {
    value: "常温",
    label: "常温（环境温度）",
  },
  {
    value: "冷藏",
    label: "冷藏（0°C〜6°C）",
  },
  {
    value: "冷冻",
    label: "冷冻（-18°C以下）",
  },
  {
    value: "恒温",
    label: "恒温（15°C〜20°C）",
  },
];
// 货品信息字段列表
export const GOODSFIELDLIST = {
  GOODS_DETAIL: [
    {
      label: '货品编码',
      prop: 'skuCode',
      default: 'defaultSkuCode',
    },
    {
      label: '数量',
      prop: 'planAmount',
      default: 'defaultPlanAmount',
      type: 'number',
    },
    {
      label: '温区',
      prop: 'warmLayer',
      list: TEMPERATURES,
      default: 'defaultWarmLayer',
      canDelete: true,
    },
    {
      label: '总重量(kg)',
      prop: 'planWeight',
      default: 'defaultPlanWeight',
      type: 'number',
    },
    {
      label: '总体积(M³)',
      prop: 'planVolume',
      default: 'defaultPlanVolume',
      type: 'number',
    },
    {
      label: '总货值(元)',
      prop: 'goodsValue',
      default: 'defaultGoodsValue',
      type: 'number',
    },
  ],
  GOODS_CATEGORY: [
    {
      label: '货品品类',
      prop: 'skuCode',
      list: [],
      default: 'defaultSkuCode',
    },
    {
      label: '数量',
      prop: 'planAmount',
      default: 'defaultPlanAmount',
      type: 'number',
    },
    {
      label: '温区',
      prop: 'warmLayer',
      list: TEMPERATURES,
      default: 'defaultWarmLayer',
      canDelete: true,
    },
    {
      label: '总重量(kg)',
      prop: 'planWeight',
      default: 'defaultPlanWeight',
      type: 'number',
    },
    {
      label: '总体积(M³)',
      prop: 'planVolume',
      default: 'defaultPlanVolume',
      type: 'number',
    },
    {
      label: '总货值(元)',
      prop: 'goodsValue',
      default: 'defaultGoodsValue',
      type: 'number',
    },
  ]
}

// 货品信息导入类型
export const GOODSTYPELIST = [
  {
    value: 'GOODS_DETAIL',
    label: '货品明细导入'
  },
  {
    value: 'GOODS_CATEGORY',
    label: '货品品类导入'
  },
]

// 货品信息货品明细导入校验规则
export const GOODSRULES = {
  skuCode: [
    { required: true, message: '请选择货品编码', trigger: 'change' },
  ],
  planAmount: [
    { required: true, message: '请选择数量', trigger: 'change' },
  ],
  category: [
    { required: true, message: '请选择货品品类', trigger: 'change' },
  ]
}

// 货品信息货品品类导入校验规则

export const GOODSCATEGORYRULES = {
  warmLayer: [
    { required: true, message: '请选择温区', trigger: 'change' },
  ],
  planWeight: [
    { required: true, message: '请选择总重量', trigger: 'change' },
  ],
  planVolume: [
    { required: true, message: '请选择总体积', trigger: 'change' },
  ],
}

// 其他信息字段列表
export const OTHERFIELDLIST = [
  {
    label: '外部订单号',
    prop: 'crmNumber',
    maxLength: 30,
    default: 'defaultCrmNumber',
  },
  {
    label: '线路标识',
    prop: 'lineRemark',
    maxLength: 30,
    default: 'defaultLineRemark',
  },
  {
    label: '是否线路计费',
    prop: 'isLine',
    default: 'defaultIsLine',
    list: [
      {
        label: '是',
        value: 'true'
      },
      {
        label: '否',
        value: 'false'
      }
    ],
  },
  {
    label: '车型名称',
    prop: 'carTypeName',
    default: 'defaultCarTypeName',
    list: [],
    canDelete: true,
  },
  {
    label: '备注',
    prop: 'remark',
    maxLength: 100,
    default: 'defaultRemark',
  },
  {
    label: '用车要求',
    prop: 'transportType',
    list: [
      {
        label: '整车',
        value: 'TRUCKLOAD'
      },
      {
        label: '零担',
        value: 'BREAK_BULK'
      }
    ],
    default: 'defaultTransportType',
  },
  {
    label: '是否提货',
    prop: 'needPickUp',
    list: [
      {
        label: '是',
        value: 'true'
      },
      {
        label: '否',
        value: 'false'
      }
    ],
    default: 'defaultNeedPickUp',
  },
  {
    label: '是否装卸',
    prop: 'needHandling',
    list: [
      {
        label: '是',
        value: 'true'
      },
      {
        label: '否',
        value: 'false'
      }
    ],
    default: 'defaultNeedHandling',
  },
  {
    label: '是否理货上架',
    prop: 'needShelves',
    list: [
      {
        label: '是',
        value: 'true'
      },
      {
        label: '否',
        value: 'false'
      }
    ],
    default: 'defaultNeedShelves',
  },
  {
    label: '销售渠道',
    prop: 'orderLabel',
    maxLength: 30,
    default: 'defaultOrderLabel',
  },
  {
    label: '其他属性',
    prop: 'expand',
    maxLength: 30,
    default: 'defaultExpand',
  },
]

export const NEEDEMPTY = {
  startStation: [
    'startTime',
    'stationCode',
    'address',
    'stationContacts',
    'stationContactsPhone',
    'stationName',
    'province',
    'city',
    'county',
  ],
  endStation: [
    'endTime',
    'stationCode',
    'address',
    'stationContacts',
    'stationContactsPhone',
    'stationName',
    'province',
    'city',
    'county',
  ],
  goods: [
    'skuCode',
    'planAmount',
    'warmLayer',
    'planWeight',
    'planVolume',
    'goodsValue',
  ],
  others: [
    'crmNumber',
    'lineRemark',
    'isLine',
    'carTypeName',
    'remark',
    'transportType',
    'needPickUp',
    'needHandling',
    'needShelves',
    'orderLabel',
    'expand',
  ]
}

export const OTHERSVALUES = {
  defaultNeedShelves: 'false',
  defaultNeedHandling: 'false',
  defaultNeedPickUp: 'false',
  defaultTransportType: 'TRUCKLOAD',
  defaultIsLine: 'false',
}
